module.exports = __webpack_public_path__ + "img/pre-pass-no.b0a37607.svg";